import { gql } from 'graphql-request'

export const UPDATE_SITE_BUSINESS_CUSTOMIZATION = gql`
  mutation UpdateSiteBusinessCustomization(
    $siteId: ID!
    $input: UpdateSiteSettingsBusinessCustomizationInputInput!
  ) {
    updateSiteSettingsBusinessCustomization(siteId: $siteId, input: $input) {
      siteId
      settings {
        location {
          businessInformation {
            name
            description
            phone
            address {
              street
              city
              state
              postalCode
              country
            }
          }
          configurations {
            dashboardRevenuePeriod
          }
        }
        customization {
          colors {
            id
            color
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_BUSINESS_LOCATIONS = gql`
  mutation UpdateSiteBusinessLocations(
    $siteId: ID!
    $input: UpdateSiteSettingsBusinessLocationsInputInput!
  ) {
    updateSiteSettingsBusinessLocations(siteId: $siteId, input: $input) {
      siteId
      displayBusinessHours
      businessHours {
        monday {
          startTime
          endTime
        }
        tuesday {
          startTime
          endTime
        }
        wednesday {
          startTime
          endTime
        }
        thursday {
          startTime
          endTime
        }
        friday {
          startTime
          endTime
        }
        saturday {
          startTime
          endTime
        }
        sunday {
          startTime
          endTime
        }
      }
    }
  }
`

export const UPDATE_SITE_SETTINGS_ACCOUNT_BILLING = gql`
  mutation UpdateSiteSettingsAccountBilling(
    $siteId: ID!
    $input: UpdateSiteSettingsAccountBillingInputInput!
  ) {
    updateSiteSettingsAccountBilling(siteId: $siteId, input: $input) {
      siteId
      name
      settings {
        account {
          billing {
            retryFailedPayments {
              maxAttempts
              intervalInDays
            }
            transactionFeePreference
            enabled
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_REGIONAL_COMMUNICATION = gql`
  mutation UpdateSiteRegionalCommunication(
    $siteId: ID!
    $input: UpdateSiteSettingsRegionalCommunicationInputInput!
  ) {
    updateSiteSettingsRegionalCommunication(siteId: $siteId, input: $input) {
      siteId
      settings {
        location {
          configurations {
            currency
            dateFormat
            numberFormat
            timeFormat
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_TIMEZONE = gql`
  mutation UpdateSiteTimezone($siteId: ID!, $timezone: String!) {
    updateSiteTimezone(siteId: $siteId, timezone: $timezone) {
      siteId
      timezone
    }
  }
`

export const TOGGLE_FRONT_DESK_KIOSK_BETA = gql`
  mutation ToggleFrontDeskKioskBeta($siteId: ID!, $enabled: Boolean!) {
    toggleFrontDeskKioskBeta(siteId: $siteId, enabled: $enabled) {
      siteId
      settings {
        location {
          tools {
            frontDeskKiosk {
              betaVersionEnabled
              isActive
              url
              customUrl
              enabledModules {
                account
                checkIn
                classCheckIn
                forms
                introOffers
                packages
              }
            }
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_SETTINGS_ACCOUNT_INVOICE = gql`
  mutation UpdateSiteSettingsAccountInvoice(
    $siteId: ID!
    $input: UpdateSiteSettingsAccountInvoiceInputInput!
  ) {
    updateSiteSettingsAccountInvoice(siteId: $siteId, input: $input) {
      siteId
      settings {
        account {
          invoice {
            label
            email
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_CHECK_IN_SETTINGS = gql`
  mutation UpdateSiteCheckInSettings($siteId: ID!, $input: UpdateSiteSettingsCheckInInputInput!) {
    updateSiteSettingsCheckIn(siteId: $siteId, input: $input) {
      siteId
      settings {
        location {
          checkIn {
            enableGeneralCheckIn
            enableMobileClientCheckIn
            enableCheckInPopups
            enableCheckInWidget
            enableCheckInSoundAlerts
            barcodeCheckInScreenRefreshPeriodInSeconds
            contactlessCheckIn {
              enabled
              enableQRCodeDeeplink
              enableForm
              formQuestions {
                id
                question
                type
                allowCheckInIfBelowOrEqualTo
                options {
                  id
                  text
                  allowCheckIn
                }
              }
              policyIds
            }
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_SETTINGS_SOCIAL_MEDIA = gql`
  mutation UpdateSiteSettingsSocialMedia(
    $siteId: ID!
    $input: UpdateSiteSettingsSocialMediaInputInput!
  ) {
    updateSiteSettingsSocialMedia(siteId: $siteId, input: $input) {
      siteId
      settings {
        location {
          socialMedia {
            website
            instagram
            facebook
            x
          }
        }
      }
    }
  }
`

export const UPDATE_SITE_SETTINGS_ACCOUNT_POINT_OF_SALE = gql`
  mutation UpdateSiteSettingsAccountPointOfSale(
    $siteId: ID!
    $input: UpdateSiteSettingsAccountPointOfSaleInputInput!
  ) {
    updateSiteSettingsAccountPointOfSale(siteId: $siteId, input: $input) {
      siteId
      settings {
        account {
          pointOfSale {
            enableCashDrawer
            itemTypes
          }
        }
      }
    }
  }
`
